import { Stack, Text, Toggle } from '@fluentui/react';
import { useTimesheetGridConfig } from '../../../hooks/useTimesheetConfig';

export const AllocationsConfigView = () => {
    const {
        showAllocations,
        showOnlyAllocatedProjects,
        onChangeShowAllocations,
        onChangeShowOnlyAllocatedProjects,
        onChangeHighlightAllocatedProjects,
        highlightAllocatedProjects,
    } = useTimesheetGridConfig();

    return (
        <Stack tokens={{ padding: 20, childrenGap: 16 }}>
            <Stack.Item>
                <Stack tokens={{ childrenGap: 4 }}>
                    <Text variant="xLarge">Allocation Settings</Text>
                    <Text variant="medium" styles={{ root: { color: '#666666' } }}>
                        Configure the settings for allocations in the timesheet grid.
                    </Text>
                </Stack>
            </Stack.Item>

            <Stack.Item>
                <Stack tokens={{ childrenGap: 4, maxWidth: 300 }}>
                    <Toggle
                        label="Show allocations for projects"
                        defaultChecked={showAllocations}
                        onText="Yes"
                        offText="No"
                        onChange={(_, checked) => {
                            onChangeShowAllocations(checked);
                        }}
                    />
                    <Text variant="small" styles={{ root: { color: '#666666' } }}>
                        Adds a column to the timesheet grid showing the project allocations.
                    </Text>
                </Stack>
            </Stack.Item>
            <Stack.Item>
                <Stack tokens={{ childrenGap: 4, maxWidth: 300 }}>
                    <Toggle
                        label="Show only allocated projects"
                        defaultChecked={showOnlyAllocatedProjects}
                        onText="Yes"
                        offText="No"
                        onChange={(_, checked) => onChangeShowOnlyAllocatedProjects(checked)}
                    />
                    <Text variant="small" styles={{ root: { color: '#666666' } }}>
                        Only display projects where the user has active allocations, including when searching.
                    </Text>
                </Stack>
            </Stack.Item>
            <Stack.Item>
                <Stack tokens={{ childrenGap: 4, maxWidth: 300 }}>
                    <Toggle
                        label="Highlight allocated projects"
                        defaultChecked={highlightAllocatedProjects}
                        onText="Yes"
                        offText="No"
                        onChange={(_, checked) => onChangeHighlightAllocatedProjects(checked)}
                    />
                    <Text variant="small" styles={{ root: { color: '#666666' } }}>
                        When on, any project row with allocation hours will be highlighted.
                    </Text>
                </Stack>
            </Stack.Item>
        </Stack>
    );
};
